import React from 'react';
import SelectList from './select-list';
import TextInput from './text-input';
import { FieldProperties } from '../form-modals';
import { FieldValues, UseFormRegister } from 'react-hook-form';

interface DependentFieldsProps {
  errors: object;
  fields: Array<FieldProperties>;
  selectValue: string;
  register: UseFormRegister<FieldValues>;
}

const DependentFields: React.FC<DependentFieldsProps> = ({ props }) => {
  const { errors, fields, register, selectValue } = props;
  return fields.map((field: FieldProperties) => {
    if (field && field.type === 'select') {
      return (
        <SelectList
          fieldProperties={field}
          selector={selectValue}
          key={field.id}
          register={register}
          errors={errors}
          dependentDropdown={true}
        />
      );
    }

    if (field && field.type === 'text') {
      return (
        <TextInput
          fieldProperties={field}
          key={field.id}
          register={register}
          errors={errors}
          fieldId={field.id}
        />
      );
    }

    return null;
  });
};

export default DependentFields;
